import React from 'react';

/**
 * T2 / IN-06: invoiced vs goods-in beside Approve. When the server blocked with receipt_discrepancy,
 * Approve is replaced by this evidence until the line is corrected, credited, or an owner overrides.
 */
export default function DeliveryCheck({ match, blocker }) {
  if (!match && !blocker) return null;
  const lines = (blocker && blocker.lines) || (match && match.lines) || [];
  const bad = lines.filter((l) => l.status && l.status !== 'ok');
  if (!bad.length && !(blocker && blocker.code === 'receipt_discrepancy')) return null;

  return (
    <section className="rounded-2xl border border-amber-300 bg-amber-50 p-5 space-y-3" data-testid="delivery-check">
      <h2 className="text-lg font-semibold text-gray-900">Delivery check</h2>
      <p className="text-sm text-gray-700" data-testid="delivery-check-summary">
        {blocker?.message || (match?.summary === 'matched' ? 'Goods-in matches this invoice.' : 'Goods-in disagrees with this invoice.')}
      </p>
      <ul className="space-y-2" data-testid="delivery-check-lines">
        {bad.map((ln, i) => (
          <li key={`${ln.item_id || ln.description}-${i}`} className="text-sm border-b border-amber-200 pb-2"
              data-testid={`delivery-check-line-${i}`}>
            <span className="font-medium">{ln.description || ln.item_id || 'Line'}</span>
            {' — '}
            invoiced {ln.invoiced_qty ?? '—'}, received {ln.received_qty ?? '—'}
            {ln.status ? ` (${ln.status})` : ''}
          </li>
        ))}
      </ul>
      {blocker?.receipt_id && (
        <p className="text-xs text-gray-600">Receipt {blocker.receipt_id}</p>
      )}
    </section>
  );
}
